<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>photo_library</md-icon>
          </div>
          <h4 class="title">Wingio Product Images</h4>
        </md-card-header>

        <md-card-content>
            <md-field>
                <label>Product Name</label>
                <md-input v-model="productDetail.name" />
            </md-field>

            <md-field>
                <label>Display Name</label>
                <md-input v-model="productDetail.displayName" />
            </md-field>

            <md-field>
                <label>Short Description</label>
                <md-textarea v-model="productDetail.shortDescription" rows="4" />
            </md-field>


            <h4 class="title pt-4 pb-2"><b>Product Specifications</b></h4>
            <div v-for="(spec, index) in productDetail.productSpecifications" :key="index" class="spec-row">
                <md-field>
                    <label>Key</label>
                    <md-input v-model="spec.key" />
                </md-field>

                <md-field>
                    <label>Value</label>
                    <md-input v-model="spec.value" />
                </md-field>

                <md-button class="md-icon-button md-danger" @click="removeSpecification(index)">
                    <md-icon>delete</md-icon>
                </md-button>
            </div>
            <div class="button-actions">
            <md-button class="md-raised md-primary" @click="addSpecification">
                Add Specification
            </md-button>
            </div>

            <div class="button-update">
            <md-button class="md-raised md-success" :disabled="isDisabled" @click="updateProduct()">
                Update Product <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
            </div>

            </md-card-content>

      </md-card>
    </div>
  </div>
</template>
<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  components: {
    
  },
  data() {
    return {
      isDisabled: false,
        productdId: this.$route.query.id,
        productDetail: {
            name: "",
            displayName: "",
            shortDescription: "",
            longDescription: "",
            productType: "Onetime",
            productSpecifications: []
        }
    };
  },
  methods: {
    getWingioProductImages() {
        OrdersDataService.getWingioProductImages({ id: this.productdId })
          .then((response) => {
            this.productDetail = response.data.produtDetail
            if (this.productDetail.stripePriceDetail?.unit_amount) {
              this.productDetail.price = this.productDetail.stripePriceDetail.unit_amount / 100;
            }
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    addSpecification() {
        this.productDetail.productSpecifications.push({ key: "", value: "" });
    },

    removeSpecification(index) {
        this.productDetail.productSpecifications.splice(index, 1);
    },
    updateProduct() {
      this.isDisabled = true;
        OrdersDataService.updateProductDetails(this.productDetail)
        .then(() => {
          this.isDisabled = false;
            this.$toast.success("Product updated successfully.");
        })
        .catch((e) => {
          this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  beforeMount() {
    this.getWingioProductImages()
  },
};
</script>

<style scoped>
.spec-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.spec-row .md-field {
  flex: 1;
}

.spec-row .md-button {
  margin-top: 20px;
}
.button-actions {
  display: flex;
  gap: 10px;
}

.button-update {
  margin-top: 20px;
  text-align: center;
}

</style>
